export function waitms(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
